import { gettext } from '@eventbrite/i18n';
import React from 'react';
import {
    IConfigContextProps,
    useConfigContext,
} from '../../contexts/ConfigContext';
import {
    trackCommunityGuidelinesClicked,
    trackPrivacyPolicyClicked,
    trackTermsOfServiceClicked,
} from '../../tracking/tos';

const TOS_TEXT = gettext(
    'I accept the <a href="/tos" class="eds-link" target="_blank" id="tos" rel="noopener noreferrer">Eventbrite  Terms of Service</a>, <a href="/community-guidelines" class="eds-link" id="community-guidelines" target="_blank" rel="noopener noreferrer">Community Guidelines</a> and have read the <a href="/privacypolicy" class="eds-link" id="privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
).toString();

const PrivacyTerms = () => {
    const configContext: IConfigContextProps = useConfigContext();
    const analytics = configContext.analytics;

    const privacyPolicyNameToHandler: { [x: string]: () => void } = {
        tos: () => {
            trackTermsOfServiceClicked({ analytics });
        },
        'community-guidelines': () => {
            trackCommunityGuidelinesClicked({ analytics });
        },
        'privacy-policy': () => {
            trackPrivacyPolicyClicked({ analytics });
        },
    };

    const _handlePrivacyPolicyClick = (e: React.SyntheticEvent) => {
        const targetId: string = (e.target as HTMLAnchorElement).id;

        if (targetId) {
            const privacyPolicyHandler = privacyPolicyNameToHandler[targetId];

            privacyPolicyHandler?.();
        }
    };

    return (
        <div className="privacy-terms eds-text--center">
            <span
                className="eds-text-color--grey-1000 eds-text-bs eds-l-mar-bot-5"
                onClick={_handlePrivacyPolicyClick}
                onKeyDown={_handlePrivacyPolicyClick}
                role="presentation"
                // Needed for links to work in gettext; no user-generated content
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: TOS_TEXT,
                }}
            />
        </div>
    );
};

export default PrivacyTerms;
